var _desc, _defs, _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobicomMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 960 540",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Mobile app UI concept") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "A mobile application UI concept with telecom balance cards, plan controls, and service tiles.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b0764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#111827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7f1d1d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e0f2fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "brand",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e879f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb7185"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 960,
    height: 540,
    fill: "url(#bg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(128 86)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 34,
    fill: "#fce7f3",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 30,
    fontWeight: 900
  }, "Mobile Application"), /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 68,
    fill: "#cbd5e1",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 17
  }, "React Native UI and app flow"), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 108,
    width: 250,
    height: 72,
    rx: 22,
    fill: "#020617",
    fillOpacity: 0.58,
    stroke: "#ffffff",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 138,
    fill: "#f8fafc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 800
  }, "Plan balance"), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 154,
    width: 164,
    height: 10,
    rx: 5,
    fill: "#64748b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 154,
    width: 118,
    height: 10,
    rx: 5,
    fill: "#fb7185"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204,
    width: 250,
    height: 72,
    rx: 22,
    fill: "#020617",
    fillOpacity: 0.58,
    stroke: "#ffffff",
    strokeOpacity: 0.14
  }), /*#__PURE__*/React.createElement("text", {
    x: 26,
    y: 234,
    fill: "#f8fafc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 800
  }, "Quick services"), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 250,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#e879f9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 250,
    width: 70,
    height: 10,
    rx: 5,
    fill: "#38bdf8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(492 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 238,
    height: 456,
    rx: 42,
    fill: "#020617",
    stroke: "#334155",
    strokeWidth: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 22,
    width: 198,
    height: 412,
    rx: 30,
    fill: "url(#screen)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 34,
    width: 72,
    height: 8,
    rx: 4,
    fill: "#0f172a",
    fillOpacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 62,
    width: 162,
    height: 96,
    rx: 24,
    fill: "url(#brand)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 96,
    fill: "#ffffff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 900
  }, "Mobi UI"), /*#__PURE__*/React.createElement("text", {
    x: 58,
    y: 124,
    fill: "#fff1f2",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 28,
    fontWeight: 900
  }, "28.4 GB"), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 136,
    width: 100,
    height: 7,
    rx: 4,
    fill: "#ffffff",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 180,
    width: 72,
    height: 68,
    rx: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 180,
    width: 72,
    height: 68,
    rx: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 266,
    width: 72,
    height: 68,
    rx: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 266,
    width: 72,
    height: 68,
    rx: 18
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#0f172a",
    fillOpacity: 0.12
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 207,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 207,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74,
    cy: 293,
    r: 14
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 164,
    cy: 293,
    r: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#64748b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 228,
    width: 40,
    height: 7,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 228,
    width: 40,
    height: 7,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 314,
    width: 40,
    height: 7,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 314,
    width: 40,
    height: 7,
    rx: 4
  })), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 358,
    width: 162,
    height: 48,
    rx: 18,
    fill: "#0f172a"
  }), /*#__PURE__*/React.createElement("text", {
    x: 65,
    y: 389,
    fill: "#f8fafc",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 900
  }, "Buy package"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(725 128)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 26,
    fill: "#fb7185",
    fillOpacity: 0.22,
    stroke: "#fb7185",
    strokeOpacity: 0.42
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 55c13-25 24-25 37 0",
    fill: "none",
    stroke: "#fecdd3",
    strokeWidth: 7,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 47,
    cy: 37,
    r: 9,
    fill: "#fecdd3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobicomMobile);
export default __webpack_public_path__ + "static/media/mobicom-mobile.732e9bfb3cd52b325d73e6a75156bb09.svg";
export { ForwardRef as ReactComponent };